import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { Company } from '@/interfaces/vuex/company';
import { required } from '@/lib/rule';
import { useDynamicListComposable } from '@/composables/useDynamicList';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';

export type RequestsForm = {
  lawRegulationIds: string[];
  description: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateByRequestsForm',
  props: {
    company: null,
    step: null,
    form: null,
    isNewUi: { type: Boolean }
  },
  emits: ["update:form"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:form', form: RequestsForm): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  company: Company;
  step: number;
  form: RequestsForm;
  isNewUi?: boolean;
};

const m = defineMessages({
  enterRequestDetails: '依頼内容を記入してください',
  enterRequestDetailsNew: 'ご相談内容を入力してください',
  requestWarning:
    '※ケミカンへ依頼する場合、5営業日〜15営業日のお時間いただく場合がございます',
  descriptionLabel: '説明（作成したいリストの詳細を記載してください）',
  enterDescription: '説明を入力...',
  enterDescriptionNew: '追加したいチェックリストの詳細を記載してください',
  clickToRequestChecklist:
    '「実行する」をクリックすると、以下の項目でケミカンにチェクリストの依頼をします。',
});





const {
  getLawText,
  getRegulationText,
  getLawRegulationText,
  lawRegulationList,
} = useDynamicListComposable();

const lawRegulationIds = ref(props.form.lawRegulationIds);
const description = ref(props.form.description);

watch(lawRegulationIds, (newValue) => {
  if (props.isNewUi) return;
  if (newValue.length === 0) {
    description.value = '';
    emit('update:form', { lawRegulationIds: newValue, description: '' });
  } else {
    const newDescription = generateRequestsDescription(newValue);
    description.value = newDescription;
    emit('update:form', {
      lawRegulationIds: newValue,
      description: newDescription,
    });
  }
});

const generateRequestsDescription = (newLawRegulationIds: string[]) => {
  const lawSet: Set<string> = new Set();
  const regulationSet: Set<string> = new Set();
  newLawRegulationIds.forEach((lawRegulationId) => {
    const [lawId, regulationId] = lawRegulationId.split('-');
    lawSet.add(lawId);
    regulationId !== 'all' ? regulationSet.add(regulationId) : null;
  });

  const longLaws = Array.from(lawSet)
    .map((lawId) => getLawText(lawId, 'long'))
    .join('、');
  const fullLaws = Array.from(lawSet)
    .map((lawId) => getLawText(lawId, 'full'))
    .join('、');
  const shortRegulations = Array.from(regulationSet)
    .map((regulationId) => getRegulationText(regulationId))
    .join('、');
  return `
リスト概要： ${longLaws}の規制対象物質を含む可能性のあるSDS

該当法令： ${fullLaws}
対象規則： ${shortRegulations}
抽出条件：
注意事項：
出典：
 `.trim();
};

return { __sfc: true,m, props, emit, getLawText, getRegulationText, getLawRegulationText, lawRegulationList, lawRegulationIds, description, generateRequestsDescription, required, sharedMessages }
}

})